export default [
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "assetsAmount",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "userCurrentAssets",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "currentTotalAssets",
                "type": "uint256"
            }
        ],
        "name": "checkDeposit",
        "outputs": [
            {
                "internalType": "bool",
                "name": "allowed",
                "type": "bool"
            },
            {
                "internalType": "string",
                "name": "reason",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            }
        ],
        "name": "userCap",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalCap",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
] as const;
